import { Theme, Tooltip } from '@infotech-soe/erp-ui-kit';
import classNames from 'classnames';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import { ConnectionIndicatorContainerProps } from './ConnectionIndicatorContainer';

export const enum ConnectionStatus {
  CONNECTED = 'connected',
  DISCONNECTED = 'disconnected',
  IN_PROGRESS = 'inProgress',
}

const useStyles = createUseStyles(({ colors }: Theme) => ({
  '@keyframes pulse': {
    '0%': { transform: 'scale(1)' },
    '50%': { transform: 'scale(1.3)' },
    '100%': { transform: 'scale(1)' },
  },

  indicator: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    transition: 'background-color 0.5s ease',
  },
  connected: {
    backgroundColor: 'lightGreen',
  },
  disconnected: {
    backgroundColor: colors.warning,
    animation: '$pulse 1s infinite',
  },
  inProgress: {
    backgroundColor: 'orange',
  },
}));

const messages = defineMessages({
  connected: {
    id: 'core.connectionStatus.connected',
    defaultMessage: 'connected to the application server',
  },
  disconnected: {
    id: 'core.connectionStatus.disconnected',
    defaultMessage: 'disconnected from the application server',
  },
  inProgress: {
    id: 'core.connectionStatus.inProgress',
    defaultMessage: 'not authenticated',
  },
});

const ConnectionIndicator = ({
  connectionStatus,
}: ConnectionIndicatorContainerProps): React.JSX.Element => {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  return (
    <Tooltip label={formatMessage(messages[connectionStatus])}>
      <div className="m-pr-sm">
        <div
          className={classNames(classes.indicator, classes[connectionStatus])}
        />
      </div>
    </Tooltip>
  );
};

export default ConnectionIndicator;
